<script setup></script>

<template>
  <svg height="24" fill="currentColor" width="24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" stroke-width="0" />
  </svg>
</template>
